// extracted by mini-css-extract-plugin
export default {"container":"CuisinesSection-module__container__jvrbK","text":"CuisinesSection-module__text__XzXUm"};